export default __webpack_public_path__ + "static/media/IMG_2121.c786e680.jpg";